import { Box, InputAdornment, TextField, useTheme } from "@mui/material";
import Iconify from "~src/components/Iconify";
import { useState } from "react";

export const PriceRangeSelector = ({
  value,
  onSelect,
}: {
  value?: string;
  onSelect: (value?: string) => void;
}) => {
  const theme = useTheme();
  const [minPrice, setMinPrice] = useState(value ? value.split("__")[0] : "");
  const [maxPrice, setMaxPrice] = useState(value ? value.split("__")[1] : "");

  // Handle change for the minimum price input
  const handleMinPriceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newMinPrice = event.target.value;
    setMinPrice(newMinPrice);
    
    // Only update if both values are valid numbers
    if (newMinPrice === "" && maxPrice === "") {
      onSelect(undefined);
      return;
    }

    const validMinPrice = newMinPrice === "" || isNaN(Number(newMinPrice)) ? "0" : newMinPrice;
    const validMaxPrice = maxPrice === "" || isNaN(Number(maxPrice)) ? "1000000" : maxPrice;
    
    // Only update if the values are different from the current value
    if (validMinPrice !== "0" || validMaxPrice !== "1000000") {
      onSelect(`${validMinPrice}__${validMaxPrice}`);
    } else {
      onSelect(undefined);
    }
  };

  // Handle change for the maximum price input
  const handleMaxPriceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newMaxPrice = event.target.value;
    setMaxPrice(newMaxPrice);
    
    // Only update if both values are valid numbers
    if (minPrice === "" && newMaxPrice === "") {
      onSelect(undefined);
      return;
    }

    const validMinPrice = minPrice === "" || isNaN(Number(minPrice)) ? "0" : minPrice;
    const validMaxPrice = newMaxPrice === "" || isNaN(Number(newMaxPrice)) ? "1000000" : newMaxPrice;
    
    // Only update if the values are different from the current value
    if (validMinPrice !== "0" || validMaxPrice !== "1000000") {
      onSelect(`${validMinPrice}__${validMaxPrice}`);
    } else {
      onSelect(undefined);
    }
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2
        }}>
        <Iconify icon={"ion:pricetag"} width={25} height={25} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 2
          }}>
          <TextField
            label="Minimum Price"
            variant="outlined"
            value={minPrice}
            onChange={handleMinPriceChange}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">Min :</InputAdornment>
                ),
              }
            }}
          />
          <TextField
            label="Maximum Price"
            variant="outlined"
            value={maxPrice}
            onChange={handleMaxPriceChange}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment
                    position="start"
                    sx={{ color: theme.palette.grey[200] }}
                  >
                    Max :
                  </InputAdornment>
                ),
              }
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};
